import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, HostListener, Input } from '@angular/core';

declare var SagDatePicker;
declare function alerts(m): any;
declare function success(m): any;
declare var sagGrid;
declare var SagInputText;
declare var SagCheckBox;
declare var setGridHight;
declare var SagGridMP;
declare var SagGridMPT;
declare var $: any;
declare var ButtonComponent;
declare var headerCheckBox;
declare var SagDynamicComp;
declare var SagSelectBox;
declare var headerSelectBox;
declare var SagToolTip;
declare var _;
declare var ui;

declare function lightboxOn();

@Directive({
  selector: '[onLoadComponent]'
})
export class OnLoadComponentDirective implements AfterViewInit {

  @Input() webCompType: any;
  @Input() webCompData: any;
  @Input('onLoadComponent') backgroundImage: string;
  constructor(
    private el: ElementRef,
    private cdRef: ChangeDetectorRef
  ) {
   // console.log(el);

  }

 ngOnInit(): void {
    // if (this.backgroundImage) {
    //   this.loadBackgroundImage();
    // }
  }

  ngAfterViewInit() {
    this.loadWebComp(this.webCompType, this.webCompData)
  }

  loadWebComp(webCompType, webCompData) {
    switch (webCompType) {
      case 'lightbox':
        this.lightBox();
        break;

      case 'owlCarousal':
        setTimeout(() => { 
          this.owlCarousal();
        }, 500);
        break;

      case 'sagTree':
        this.sagTree();
        break;

      case 'megnifyZoom':
        this.onMegnifyZoom(webCompData);
        break;

      case 'menu':
        this.menu(webCompData);
        break;

      case 'footer':
        this.footer(webCompData);
        break;

      case 'header':
        this.header(webCompData);
        break;


      default:
        break;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.webCompType == 'footer'){
      this.loadWebComp(this.webCompType, this.webCompData)
    } else if (this.webCompType == 'header') {
      this.loadWebComp(this.webCompType, this.webCompData)
    }
  }


  lightBox() {
    lightboxOn();
  }

  owlCarousal() {
    if (typeof $ !== 'undefined') {
    const elem = $(`${this.webCompData['class']}`);
    this.cdRef.detectChanges();
    // console.log(elem);
    this.webCompData["responsive"] = {
      0: {
        items: this.webCompData.mobileSection || 1,
      },
      600: {
        items: this.webCompData.tabletSection || this.webCompData.items,
      },
      1000: {
        items: this.webCompData.items,
      }
    };
    elem.owlCarousel(this.webCompData);
  }

  }


  onMegnifyZoom(webCompData) {
    setTimeout(() => {
      if (typeof $ !== 'undefined') {
      this.zoomMethod(webCompData);
      this.zoomPrevNext(webCompData);
      }
    }, 1000)

  }

  zoomMethod(webCompData) {
    const elemUsingId = $(`.${webCompData['id']}, .xzoom-gallery-${webCompData['id']}`);
    elemUsingId.xzoom(
      this.webCompData =
        {
        zoomWidth: 720,
        zoomHeight: 650,
        // title: true,
        // tint: '#333',
        // Xoffset: 15,
        // position: "left",
        // smoothZoomMove: 10,
        // smoothLensMove: 10,
        // lensShape:"circle"
      }
    );
    //  elemUsingId.xzoom({ zoomWidth: 400, });
    // elemUsingId.xzoom({ position: '#xzoom2-id', tint: '#ffa200' });
    // elemUsingId.xzoom({ position: 'lens', lensShape: 'circle', sourceClass: 'xzoom-hidden' });
    // elemUsingId.xzoom({ tint: '#006699', Xoffset: 15 });
    // elemUsingId.xzoom({ tint: '#006699', Xoffset: 15 });

    //Integration with hammer.js
    var isTouchSupported = 'ontouchstart' in window;

    if (isTouchSupported) {
      //If touch device
      // $('.xzoom, .xzoom2, .xzoom3, .xzoom4, .xzoom5').each(function () {
      //   var xzoom = $(this).data('xzoom');
      //   xzoom.eventunbind();
      // });

      elemUsingId.each(function () {
        var xzoom = $(this).data('xzoom');
        xzoom.eventunbind();
      });



      elemUsingId.each(function () {
        var xzoom = $(this).data('xzoom');
        $(this).hammer().on("tap", function (event) {
          event.pageX = event.gesture.center.pageX;
          event.pageY = event.gesture.center.pageY;
          var s = 1, ls;

          xzoom.eventmove = function (element) {
            element.hammer().on('drag', function (event) {
              event.pageX = event.gesture.center.pageX;
              event.pageY = event.gesture.center.pageY;
              xzoom.movezoom(event);
              event.gesture.preventDefault();
            });
          }

          xzoom.eventleave = function (element) {
            element.hammer().on('tap', function (event) {
              xzoom.closezoom();
            });
          }
          xzoom.openzoom(event);
        });
      });

      // $('.xzoom4').each(function () {
      //   var xzoom = $(this).data('xzoom');
      //   $(this).hammer().on("tap", function (event) {
      //     event.pageX = event.gesture.center.pageX;
      //     event.pageY = event.gesture.center.pageY;
      //     var s = 1, ls;

      //     xzoom.eventmove = function (element) {
      //       element.hammer().on('drag', function (event) {
      //         event.pageX = event.gesture.center.pageX;
      //         event.pageY = event.gesture.center.pageY;
      //         xzoom.movezoom(event);
      //         event.gesture.preventDefault();
      //       });
      //     }

      //     var counter = 0;
      //     xzoom.eventclick = function (element) {
      //       element.hammer().on('tap', function () {
      //         counter++;
      //         if (counter == 1) setTimeout(openfancy, 300);
      //         event.gesture.preventDefault();
      //       });
      //     }

      //     function openfancy() {
      //       if (counter == 2) {
      //         xzoom.closezoom();
      //         $.fancybox.open(xzoom.gallery().cgallery);
      //       } else {
      //         xzoom.closezoom();
      //       }
      //       counter = 0;
      //     }
      //     xzoom.openzoom(event);
      //   });
      // });

      // $('.xzoom5').each(function () {
      //   var xzoom = $(this).data('xzoom');
      //   $(this).hammer().on("tap", function (event) {
      //     event.pageX = event.gesture.center.pageX;
      //     event.pageY = event.gesture.center.pageY;
      //     var s = 1, ls;

      //     xzoom.eventmove = function (element) {
      //       element.hammer().on('drag', function (event) {
      //         event.pageX = event.gesture.center.pageX;
      //         event.pageY = event.gesture.center.pageY;
      //         xzoom.movezoom(event);
      //         event.gesture.preventDefault();
      //       });
      //     }

      //     var counter = 0;
      //     xzoom.eventclick = function (element) {
      //       element.hammer().on('tap', function () {
      //         counter++;
      //         if (counter == 1) setTimeout(openmagnific, 300);
      //         event.gesture.preventDefault();
      //       });
      //     }

      //     function openmagnific() {
      //       if (counter == 2) {
      //         xzoom.closezoom();
      //         var gallery = xzoom.gallery().cgallery;
      //         var i, images = new Array();
      //         for (i in gallery) {
      //           images[i] = { src: gallery[i] };
      //         }
      //         $.magnificPopup.open({ items: images, type: 'image', gallery: { enabled: true } });
      //       } else {
      //         xzoom.closezoom();
      //       }
      //       counter = 0;
      //     }
      //     xzoom.openzoom(event);
      //   });
      // });

    } else {
      //If not touch device

      //Integration with fancybox plugin
      $('#xzoom-fancy').bind('click', function (event) {
        var xzoom = $(this).data('xzoom');
        xzoom.closezoom();
        $.fancybox.open(xzoom.gallery().cgallery, { padding: 0, helpers: { overlay: { locked: false } } });
        event.preventDefault();
      });

      //Integration with magnific popup plugin
      $('#xzoom-magnific').bind('click', function (event) {
        var xzoom = $(this).data('xzoom');
        xzoom.closezoom();
        var gallery = xzoom.gallery().cgallery;
        var i, images = new Array();
        for (i in gallery) {
          images[i] = { src: gallery[i] };
        }
        $.magnificPopup.open({ items: images, type: 'image', gallery: { enabled: true } });
        event.preventDefault();
      });
    }



  }
  zoomPrevNext(webCompData) {
    let topPrevBtn = document.querySelector(".zoomContainerBottom");
    let bottomNextBtn = document.querySelector(".zoomContainerTop");
    // let leftPrevBtn = document.querySelector(".zoomContainerLeft");
    // let rightNextBtn = document.querySelector(".zoomContainerRight");

    if (topPrevBtn != null || bottomNextBtn != null) {
      let prevBtn = document.querySelector("#prevId");
      let nextBtn = document.querySelector("#nextId");
      let bottomGalleryClientWidth = document.querySelector(".bottom_gallary").clientWidth;
      let bottomGalleryScrollWidth = document.querySelector(".bottom_gallary").scrollWidth;
      let bottomGalleryImg = document.getElementsByClassName("xzoom-gallery")[0]['offsetWidth'];
      let bottomGallery = document.querySelector(".bottom_gallary");
      if (bottomGalleryClientWidth < bottomGalleryScrollWidth) {
        prevBtn.addEventListener("click", function () {
          bottomGallery.scrollLeft -= bottomGalleryImg;
        })
        nextBtn.addEventListener("click", function () {
          bottomGallery.scrollLeft += bottomGalleryImg;
        })
      }
    } else {
      const xzoomDefault = document.getElementById('xzoom-default').clientHeight;
      const getXzoomDefaultgallery = document.querySelector<HTMLElement>(".xzoom-thumbs");
      getXzoomDefaultgallery.style.height = xzoomDefault + "px"
      let getXzoomContainer = document.querySelector<HTMLElement>(".xzoom-container");
      getXzoomContainer.style.display = 'flex';
      let prevBtn = document.querySelector("#prevId");
      let nextBtn = document.querySelector("#nextId");
      let bottomGalleryClientHeight = document.querySelector(".bottom_gallary").clientHeight;
      let bottomGalleryScrollHeight = document.querySelector(".bottom_gallary").scrollHeight;
      let bottomGalleryImg = document.getElementsByClassName("xzoom-gallery")[0]['offsetHeight'];
      let bottomGallery = document.querySelector(".bottom_gallary");
      if (bottomGalleryClientHeight < bottomGalleryScrollHeight) {
        prevBtn.addEventListener("click", function () {
          bottomGallery.scrollTop += bottomGalleryImg;
        })
        nextBtn.addEventListener("click", function () {
          bottomGallery.scrollTop -= bottomGalleryImg;
        })
      }
    }
  }
// not working js next prev 
  // zoomPrevNext(webCompData) {
  //   if (typeof document !== 'undefined') {
  //   let topPrevBtn = document.querySelector(".zoomContainerBottom");
  //   let bottomNextBtn = document.querySelector(".zoomContainerTop");
  //   // let leftPrevBtn = document.querySelector(".zoomContainerLeft");
  //   // let rightNextBtn = document.querySelector(".zoomContainerRight");

  //   if (topPrevBtn != null || bottomNextBtn != null) {
  //     let prevBtn = document.querySelector("#prevId") as HTMLElement;
  //     let nextBtn = document.querySelector("#nextId") as HTMLElement;
  //     let bottomGalleryClientWidth = document.querySelector(".bottom_gallary").clientWidth;
  //     let bottomGalleryScrollWidth = document.querySelector(".bottom_gallary").scrollWidth;
  //     let bottomGalleryImg = document.getElementsByClassName("xzoom-gallery")[0]['offsetWidth'];
  //     let bottomGallery = document.querySelector(".bottom_gallary");
  //     if (bottomGalleryClientWidth < bottomGalleryScrollWidth) {
  //       prevBtn.style.display='inline-flex';
  //       nextBtn.style.display='inline-flex';
  //       prevBtn.addEventListener("click", function () {
  //         bottomGallery.scrollLeft -= bottomGalleryImg;
  //       })
  //       nextBtn.addEventListener("click", function () {
  //         bottomGallery.scrollLeft += bottomGalleryImg;
  //       })
  //     }else{
  //       prevBtn.style.display='none';
  //       nextBtn.style.display='none';
  //     }
  //   } else {
  //     const xzoomDefault = document.getElementById('xzoom-default').clientHeight;
  //     const getXzoomDefaultgallery = document.querySelector<HTMLElement>(".xzoom-thumbs");
  //     getXzoomDefaultgallery.style.height = xzoomDefault + "px"
  //     let getXzoomContainer = document.querySelector<HTMLElement>(".xzoom-container");
  //     getXzoomContainer.style.display = 'flex';

  //     let prevBtn = document.querySelector("#prevId") as HTMLElement;
  //     let nextBtn = document.querySelector("#nextId") as HTMLElement;
  //     let bottomGalleryClientHeight = document.querySelector(".bottom_gallary").clientHeight;
  //     let bottomGalleryScrollHeight = document.querySelector(".bottom_gallary").scrollHeight;
  //     let bottomGalleryImg = document.getElementsByClassName("xzoom-gallery")[0]['offsetHeight'];
  //     let bottomGallery = document.querySelector(".bottom_gallary") as HTMLElement;
  //     if (bottomGalleryClientHeight < bottomGalleryScrollHeight) {
  //       prevBtn.addEventListener("click", function () {
  //         bottomGallery.scrollTop += bottomGalleryImg;
  //       })
  //       nextBtn.addEventListener("click", function () {
  //         bottomGallery.scrollTop -= bottomGalleryImg;
  //       })
  //     }else{
  //       prevBtn.style.display='none';
  //       nextBtn.style.display='none';
  //       bottomGallery.style.height = 'auto';
  //       getXzoomDefaultgallery.style.justifyContent = 'flex-end';
  //     }
  //   }
  // }
  // }

  sagTree() {
    if (typeof document !== 'undefined') {
    var toggler = document.getElementsByClassName("caret");
    var i;

    for (i = 0; i < toggler.length; i++) {
      toggler[i].addEventListener("click", function () {
        this.parentElement.querySelector(".nested").classList.toggle("active");
        this.classList.toggle("caret-down");
      });
    }
  }
  }
  /**
   * to handle submenu layer
   */
  menu(webCompData) {
    if (typeof $ !== 'undefined') {
    const elem = $(`${this.webCompData['id']}`);
    this.cdRef.detectChanges();
    setTimeout(() => {
      $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
        if (!$(this).next().hasClass('show')) {
          $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        var $subMenu = $(this).next(".dropdown-menu");
        $subMenu.toggleClass('show');

        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
          $('.dropdown-submenu .show').removeClass("show");
        });

        return false;
      });
    }, 1000);
  }
  }

  footer(webCompData) {
    if (typeof document !== 'undefined') {
    if (document.querySelector(".fixed-bottom") !== null) {
      const elem = document.getElementById(webCompData['id']);
      let fixedBottomHeight = elem.children[0].clientHeight;
      elem.previousSibling['style'].paddingBottom = fixedBottomHeight + 'px';
      if (this.webCompData
        && this.webCompData.footerFixed
      ) {
        elem
      }
    }
  }
}

  header(webCompData) {
    if (typeof document !== 'undefined') {
    if (document.querySelector(".fixed-top") !== null) {
      const elem = document.getElementById(webCompData['id']);
      let fixedTopHeight = elem.clientHeight;
      elem.nextElementSibling['style'].paddingTop = fixedTopHeight + 'px';
      if (this.webCompData
        && this.webCompData.headerFixed
      ) {
        elem
      }
    }
  }
  }

  // loadBackgroundImage(): void {
  //   const element = this.el.nativeElement;
  //   if (!window.IntersectionObserver) return
  //   const observer = new IntersectionObserver(entries => {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting) {
  //         element.style.backgroundImage = `url(${this.backgroundImage})`;
  //         observer.unobserve(element);
  //       }
  //     });
  //   });

  //   observer.observe(element);
  // }
}
